import { styledComponent } from '@hermes/web-components'

export const Container = styledComponent('div')`
  display: flex;
  flex-direction: column;
  `

export const ProudlyText = styledComponent('h2')`
  font-weight: 700;
  font-size: 24px;
  color: #2A2461;
  text-wrap: nowrap;
  margin: 0;
  `

export const TrustedByContainer = styledComponent('div')`
  display: flex;
  gap: 24px;
  height: 72px;
  align-items: center;
  overflow: hidden;
  @media (max-width: 768px) {
  flex-direction: column;
  height: 100%;
  }
  `

export const Line = styledComponent('div')`
  background-color: #11245A;
  height: 100%;
  width: 1px;
  min-width: 1px;
  `
